import { ProjectTypeDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectTypeService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProjectType(): Observable<ProjectTypeDto[]> {
    return this.http.get<ProjectTypeDto[]>(this.url + 'project-type');
  }

  createProjectType(data: ProjectTypeDto[]): Observable<ProjectTypeDto[]> {
    return this.http.post<ProjectTypeDto[]>(this.url + 'project-type', data);
  }
  getSingleProjectType(id: string): Observable<any> {
    return this.http.get(this.url + 'project-type/' + id);
  }

  updateProjectType(data: ProjectTypeDto[]): Observable<ProjectTypeDto[]> {
    return this.http.post<ProjectTypeDto[]>(
      this.url + 'project-type/update',
      data
    );
  }

  deleteProjectType(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-type', ids.join(', '));
    return this.http.delete(this.url + 'project-type', httpOptions);
  }
}
